// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// DEPENDENCIES
import { compose } from 'redux';

// HELPERS
import { withRouter } from 'helpers/withRouter';

//Render
const RenderVehicleRegistration = compose(withRouter)(() => (
  <Form.Body>
    <Form.PlainText label="Address" name="registration_address1" />
    <Form.PlainText label="City" name="registration_city" />
    <Form.PlainText label="State" name="registration_state" />
    <Form.PlainText label="County" name="registration_county" />
    <Form.PlainText label="Zip" name="registration_zip_code" />
  </Form.Body>
));

export default function VehicleRegistrationInfo(props) {
  return <Card title="Vehicle Registration Address" body={<RenderVehicleRegistration {...props} />} />;
}
